import Alpine from "alpinejs";
import mask from "@alpinejs/mask";

Alpine.plugin(mask);

Alpine.data("form", () => ({
    init() {
        if (location.search.includes("validate=true")) {
            this.$nextTick(() => {
                this.$el.querySelectorAll("[aria-invalid='true']").forEach((field) => {
                    field.setCustomValidity(document.getElementById(`${field.id}_errors`).textContent);
                    const change = field.addEventListener("change", () => {
                        field.setCustomValidity("");
                        field.removeEventListener("change", change);
                    });
                });
                this.$el.reportValidity();
            });
        }
    },
}));
